import Modal from "react-responsive-modal";
import "./modal.scss";
import { ReactElement, ReactNode } from "react";

interface IGenericModalProps {
  open: boolean;
  setOpen: (item: boolean) => void;
  title?: string;
  iconTitle?: ReactElement;
  text?: string;
  children?: JSX.Element[] | JSX.Element | ReactNode;
  showActionsButtons?: boolean;
  rightButtonText?: string | JSX.Element;
  leftButtonText?: string | JSX.Element;
  rightButtonStyle?: any;
  leftButtonStyle?: any;
  leftButtonAction?: (e?: any) => any;
  rightButtonAction?: () => any;
  containerStyle?: any;
  actionsStyle?: any;
  onClose?: () => any;
}
export default function GenericModal({
  open,
  setOpen,
  children,
  title,
  iconTitle,
  text,
  showActionsButtons = false,
  rightButtonText,
  leftButtonText,
  rightButtonStyle,
  leftButtonStyle,
  rightButtonAction,
  leftButtonAction,
  containerStyle,
  actionsStyle,
  onClose
}: IGenericModalProps) {

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          if (onClose) onClose()
          setOpen(false)
        }}
        showCloseIcon={false}
        center
      >
        <div className='generic-modal-body' style={containerStyle}>
          {iconTitle && <span className='icon-title'>{iconTitle}</span>}
          {title && <span className='title'>{title}</span>}
          {text && <p className='subtitle'>{text}</p>}

          {children && <div className='generic-children'>
            {children}
          </div>}


          {showActionsButtons && <div className='actions-buttons' style={actionsStyle}>
            <button
              className='cancel'
              onClick={(e) => leftButtonAction ? leftButtonAction(e) : setOpen(false)}
              style={leftButtonStyle}
            >
              {leftButtonText}
            </button>
            <button
              className='save'
              style={rightButtonStyle}
              onClick={rightButtonAction}
            >
              {rightButtonText}
            </button>
          </div>}
        </div>
      </Modal>
    </>
  )
}